import { Offer } from "./Offer";
import { Plan } from "./Plan";
import { Status, SubscriptionUserInfo } from "./Subscription";

export enum EntitlementKind {
  MAIN = "main",
  PASS = "pass",
  SINGLE_GAME = "singlegame",
  UBISOFT_PLUS = "ubisoftplus",
}

export enum EntitlementStatus {
  ACTIVE = "active",
  UNACTIVE = "unactive",
}

export interface EntitlementSubscription {
  status: Status;
  uuid: string;
  cancelDate?: string;
  cancelDateUpdatedAt?: string;
  organizationName: string;
  partnerId: string;
  purchaseDate: string;
  currentPeriodEnd: string;
  redemptionCode?: string;
  userInfo?: SubscriptionUserInfo;
  customData?: Record<string, string>;
}

export interface Entitlement {
  uuid: string;

  kind: EntitlementKind;
  name: string;
  offer?: Offer;
  plan?: Plan;
  status: EntitlementStatus;
  /**
   * In case of pass, items is an array containing pass uuid
   */
  items?: string[];
  subscription?: EntitlementSubscription;
}
